// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unlocked-feature {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #242b37;
  border: 0.1vw solid #00ffff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 
    0 0 10px rgba(0, 255, 255, 0.3),
    0 0 20px rgba(0, 255, 255, 0.2),
    inset 0 0 8px rgba(0, 255, 255, 0.2);
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
  min-width: 400px;
}

.unlocked-feature-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
}

.unlocked-feature-header {
  color: #e0e0e0;
  font-size: 1.5rem;
  margin: 0;
  font-family: Kim;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.unlocked-feature-description {
  color: #e0e0e0;
  font-size: 1.1rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.unlocked-feature-rewards {
  display: inline-flex;
  gap: 16px;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.unlocked-feature-reward-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unlocked-feature-reward-icon {
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
}

.unlocked-feature-reward-amount {
  position: absolute;
  bottom: -8px;
  right: -8px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 0.8rem;
  min-width: 20px;
  text-align: center;
}

.unlocked-feature-buttons {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.unlocked-feature-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-family: Kim;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.unlocked-feature-button.primary {
  background: linear-gradient(to bottom, #ffcc00, #ff9900);
  color: #242b37;
  border: 1px solid #ffaa00;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 2px 4px rgba(255, 153, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.unlocked-feature-button.primary:hover {
  background: linear-gradient(to bottom, #ffdd33, #ffaa00);
  transform: translateY(-2px);
  box-shadow: 
    0 4px 8px rgba(255, 153, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.unlocked-feature-button.secondary {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid #e0e0e0;
  color: #e0e0e0;
  box-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.2),
    inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}

.unlocked-feature-button.secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: #ffffff;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 
    0 4px 8px rgba(0, 0, 0, 0.3),
    inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.unlocked-feature-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@media (max-width: 768px) {
  .unlocked-feature {
    width: 90%;
    min-width: 0;
    padding: 16px;
  }
}

.unlocked-feature-rewards-header {
  color: #e0e0e0;
  font-size: 1rem;
  margin: 0;
  margin-bottom: -8px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
} `, "",{"version":3,"sources":["webpack://./src/components/popups/unlockedFeature/UnlockedFeature.style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb;;;wCAGsC;EACtC,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,cAAc;EACd,yBAAyB;EACzB,6CAA6C;EAC7C;;0CAEwC;AAC1C;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;EAC3B;;0CAEwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd;;4CAE0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B;;4CAE0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C","sourcesContent":[".unlocked-feature {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #242b37;\n  border: 0.1vw solid #00ffff;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: \n    0 0 10px rgba(0, 255, 255, 0.3),\n    0 0 20px rgba(0, 255, 255, 0.2),\n    inset 0 0 8px rgba(0, 255, 255, 0.2);\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n  min-width: 400px;\n}\n\n.unlocked-feature-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  text-align: center;\n}\n\n.unlocked-feature-header {\n  color: #e0e0e0;\n  font-size: 1.5rem;\n  margin: 0;\n  font-family: Kim;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.unlocked-feature-description {\n  color: #e0e0e0;\n  font-size: 1.1rem;\n  margin: 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.unlocked-feature-rewards {\n  display: inline-flex;\n  gap: 16px;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n}\n\n.unlocked-feature-reward-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.unlocked-feature-reward-icon {\n  width: 32px;\n  height: 32px;\n  background-repeat: no-repeat;\n}\n\n.unlocked-feature-reward-amount {\n  position: absolute;\n  bottom: -8px;\n  right: -8px;\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  padding: 2px 4px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  min-width: 20px;\n  text-align: center;\n}\n\n.unlocked-feature-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.unlocked-feature-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-family: Kim;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.unlocked-feature-button.primary {\n  background: linear-gradient(to bottom, #ffcc00, #ff9900);\n  color: #242b37;\n  border: 1px solid #ffaa00;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.3);\n  box-shadow: \n    0 2px 4px rgba(255, 153, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n.unlocked-feature-button.primary:hover {\n  background: linear-gradient(to bottom, #ffdd33, #ffaa00);\n  transform: translateY(-2px);\n  box-shadow: \n    0 4px 8px rgba(255, 153, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n.unlocked-feature-button.secondary {\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid #e0e0e0;\n  color: #e0e0e0;\n  box-shadow: \n    0 2px 4px rgba(0, 0, 0, 0.2),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.1);\n}\n\n.unlocked-feature-button.secondary:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: #ffffff;\n  color: #ffffff;\n  transform: translateY(-2px);\n  box-shadow: \n    0 4px 8px rgba(0, 0, 0, 0.3),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n\n.unlocked-feature-button:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@media (max-width: 768px) {\n  .unlocked-feature {\n    width: 90%;\n    min-width: 0;\n    padding: 16px;\n  }\n}\n\n.unlocked-feature-rewards-header {\n  color: #e0e0e0;\n  font-size: 1rem;\n  margin: 0;\n  margin-bottom: -8px;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
